import React from 'react';
import { useCategoriesManager } from '../hooks/useCategoriesManager';
import CategoryStudioView from './CategoryStudioView';

const Categories: React.FC = () => {
  const manager = useCategoriesManager();
  return <CategoryStudioView manager={manager} />;
};

export default Categories;
